<template>
  <div class="tile">
    <div>
      <h2>{{title}}</h2>
      <!-- <div class="break"></div>  -->
      <h6><span>APP KEY -</span> f1bf17d9-6a4d-4a15-b315-a6fa82167ba6</h6>    
    </div>
    <div class="plan-tag">{{planName}}</div>


  </div>
</template>

<script>
export default {
  name: "TileButton",
  props: {
    title: String,
    img: String,
    planName: String,

  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.break {
  flex-basis: 100%;
  height: 0;
}

h2,h6 {
  margin:10px;
}
h3 {
  margin: 40px 0 0;
}
h6 {
  font-family: Inter;
  font-size: 0.8em;
  letter-spacing: 1px;
  font-weight: 300; 
  span {
    letter-spacing: 0;
  }
}

ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.hello {
  width: 70%;
  text-align: left;
  // margin: auto;
  line-height: 1.3;
}

.tile {
  display: flex;
  background-color: black;
  flex-grow: 1;
  flex-shrink: 0;
  flex-basis: 33.3333%;
  flex-basis: 200px;
  // flex-wrap: wrap;
  font-family: "Poppins";
  color: white;
  text-align: left;
  height: 180px;
  padding: 20px;
  align-items: center;
  // margin: 10px;
  margin-top:30px;
  // box-shadow:  0 5px 10px rgba(0,0,0,0.12);
  background-size: cover;
  border-radius: 20px;
  cursor: pointer;
  transition: transform 0.2s ease-out, box-shadow 0.2s ease-out;
  position: relative;
}

.tile:hover {
  box-shadow:  0 5px 10px rgba(0,0,0,0.22);
  transform:scale(1.008);

}

.plan-tag {
  position: absolute;
  right: 0;
  // bottom: 0;
  padding: 22px;
  font-weight:bold;
  letter-spacing: 2px;
  text-transform: uppercase;
}



</style>
